<nav>
    <div id='nav-inner'>
        <svg id="signature-svg" ref='signature' viewBox="0 0 1900 1300" xmlns="http://www.w3.org/2000/svg">
            <!--Ja--> <path class='sigJa sigPart' stroke-dasharray="4295" stroke-dashoffset="0"
                d="M622.85 552.34c-45.62-79.51-56.05-101.02-78.208-117.31-63.87-46.925-70.387-46.273-79.51-49.532-72.995-39.104-128.91-62.12-128.91-62.12s89.155 48.434 154.98 62.12c41.71 7.82 86.19-13.198 95.152-18.248 27.7-14.827 71.14-46.432 110.79-91.242 18.736-21.173 34.28-45.73 50.835-80.815s19.11-66.6 18.24-101.67c-.18-7.23-1.42-14.072-11.73-18.248-12.85-5.2-20.51 7.795-35.2 22.16s-40.41 51.483-70.39 102.97c-29.98 51.49-86.03 174.66-86.03 174.66s-157.81 348.6-264.6 567.01c-82.98 149.67-99.96 177.84-149.81 248.74-36.19 51.464-55.28 66.716-88.73 62.79-41.83-4.91-45.62-69.085-48.23-93.85-7.82-61.263-9.12-109.49-1.3-177.27 13.03-84.725 25.75-129.36 60.4-217.68 50.39-100.14 119.47-191.61 165.09-243.75 46.92-46.925 71.69-69.083 125.13-110.79C409.06 381.59 448 384.36 461.2 382.892c19.226-.978 45.025 14.47 124.75-10.875 16.59-23.964 24.74-38.578 39.486-39.96 10.6 8.295 28.53 5.28 23.46 11.73-5.07 1.844-7.33-10.888-23.46-10.427-17.05 5.99-24.987 13.262-39.104 35.193-14.116 21.932-27.595 45.605-31.282 99.063 1.843 36.867 10.11 38.024 15.64 41.71 29.496-2.303 35.26-24.96 41.71-44.317 10.14-31.8 26.07-86.03 26.07-86.03s-20.63 58.74-16.943 95.15c12.907 32.26 15.17 25.13 23.465 33.89 18.896 1.84 35.194-44.32 35.194-44.32"/>
            <!--c--> <path class='sigC sigPart' stroke-dasharray="247" stroke-dashoffset="0"
                d="M728.45 354.17l-9.124-1.304c-13.686 13.687-16.945 18.9-22.16 28.677-14.337 26.07-20.203 41.06-24.765 58.656-2.6 19.55-2.96 21.34 1.31 30.63 3.85 8.38 11.11 17.38 20.21 18.9 11.51 1.91 22.22-7.88 31.94-14.34 11.39-7.58 23.46-21.51 29.98-28.03"/>
            <!--o--> <path class='sigO sigPart' stroke-dasharray="348" stroke-dashoffset="0"
                d="M787.25 380.08s2.233-13.043-1.843-17.05c-3.63-3.57-10.698-3.743-15.208-1.383-22.07 11.544-30.81 37.85-37.79 61.753-5.59 19.122-7.4 32.424-10.6 48.85-1.51 7.75 6.43 18.064 14.28 18.893 14.94 1.578 25.02-17.52 34.1-29.494 12.2-16.1 20.41-35.37 25.8-54.84 4.9-17.71 5.53-54.84 5.53-54.84"/>
            <!--b--> <path class='sigB sigPart' stroke-dasharray="638" stroke-dashoffset="0"
                d="M810.55 233.28s3.813-18.53 10.754-17.923c6.953.608 6.225 12.69 7.495 19.552 4.17 22.53 1.87 45.91 0 68.75-2.08 25.23-4.33 50.94-12.39 74.95-10.55 31.41-23.34 68.33-23.14 68.75 0 0-4.33 15.06 0 14.99 16.1-.26 9.15-31.76 19.22-44.32 8.31-10.38 19.28-20.59 32.26-23.47 9.4-2.08 20.89-.55 28.35 5.54 10.94 8.93 16.04 24.98 16.29 39.1.23 12.99-6.61 25.6-13.69 36.492-10.05 15.46-24.22 31.14-42.04 37.475-14.54 5.163-25.83-9.766-34.87-19.556-9.17-9.93-15.5-23.39-16.95-36.82-.49-4.53 2.93-13.36 2.93-13.36"/>
            <!--R1--> <path class='sigR1 sigPart' stroke-dasharray="317" stroke-dashoffset="0"
                d="M1073.85 239.06L1062.79 228s.116 94.225-4.61 141.02c-4.412 43.72-8.77 88.092-22.12 129.96-2.794 8.77-11.98 24.886-11.98 24.886"/>
            <!--R2--> <path class='sigR2 sigPart' stroke-dasharray="1430" stroke-dashoffset="0"
                d="M821.35 203.12s15.892-55.298 33.18-77.422c27.546-35.247 67.04-60.84 106.92-81.108 40.033-20.346 84.27-35.17 129.04-38.71 41.41-3.28 84.37 2.67 123.51 16.59 42.1 14.97 85.953 35.5 114.29 70.047 7.89 9.62 13.15 22.585 12.905 35.024-.38 19.29-10.08 38.4-22.12 53.46-23.947 29.97-60.825 47.13-94.012 66.36-42.81 24.82-88.592 44.38-134.57 62.68-25.275 10.06-50.222 25.4-77.422 25.81-12.82.2-36.74 1.77-36.86-11.06-.17-18.07 33.57-15.56 51.62-16.59 18.77-1.06 39.08 1.56 55.3 11.06 19.56 11.45 34.61 31.11 44.24 51.62 9.28 19.75 9.21 42.78 11.06 64.52 1.72 20.21 0 60.83 0 60.83l9.22 12.91"/>
            <!--unge--> <path class='sigUnge sigPart' stroke-dasharray="2118" stroke-dashoffset="0"
                d="M1149.45 348.74s-9.224 66.466 0 97.7c3.524 11.93 7.927 29.826 20.277 31.336 13.376 1.636 23.232-15.718 29.494-27.65 11.55-22.008 11.06-73.736 11.06-73.736s-12.94 59.256-3.68 86.64c1.54 4.545 4.43 11.37 9.22 11.06 21.78-1.42 35.03-55.302 35.03-55.302v53.458s1.71-67.798 21.04-88.91c7.49-8.175 17.12-12.56 25.61-9.33 9.32 3.55 14.19 26.348 14.19 26.348l1.85 70.048s36-16.693 44.24-33.18c7.7-15.39 16.36-46.276 0-51.615-18.81-6.14-34.59 33.36-35.02 53.142-.28 13.29 10.31 26.7 22.12 27.96 13.46 1.43 24.19-14.32 31.34-25.81 5.67-9.12 7.38-31.34 7.38-31.34s21.56 112.03 14.75 167.75c-5.05 41.27-13.6 105.25-54.24 114.07-15.714 3.41-17.334-10.73-19.492-31.12-2.157-20.39 16.32-55.54 29.496-81.11 26.31-51.06 64.176-95.3 97.7-141.94 8.96-12.48 28.74-21.55 27.65-36.87-.494-6.94-8.61-18.01-14.75-14.75-14.37 7.62-.953 35.23 9.218 47.93 9.635 12.02 27.206 15.85 42.4 18.43 41.303 7.02 84.28-.94 125.35-9.22 69.904-14.1 202.77-68.21 202.77-68.21"/>
            <!--Underline--> <path class='sigLine sigPart' stroke-dasharray="1235" stroke-dashoffset="0"
                d="M 327.20575,616.08499 C 636.13965,529.12582 1409.6185,494.79982 1553.7877,501.66502"/>
        </svg>

        <div ref='tagline' id='tagline'>
            I'm a web developer who is <strong>front-end</strong> passionate, <strong>back-end</strong> proficient, and dedicated to fun and intuitive <strong>user experience</strong>.
        </div>

        <div id='top-links'>
            <a href='#abouthash' class='box white'>See my work</a>
        </div>
    </div>
</nav>

<style lang='scss'>
    @import "../variables.scss";

    nav {
        height: 100vh;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #nav-inner {
        width: 90%;
        max-width: 40em;
        max-height: 20em;
        top: 5em;
        position: relative;
        display: flex;
        flex-direction: column;
    }

    #signature-svg
    {
        width: 100%;
        max-width: 25em;
        position: absolute;
        top: -9em;

        path
        {
            fill: none;
            stroke: #FFFFFF;
            stroke-width: 8;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-miterlimit: 10;
        }
    }

    @keyframes sigJa {
        0% { visibility: visible; stroke-dashoffset: 4295; }
        100% { visibility: visible; stroke-dashoffset: 0; }
    }
    @keyframes sigC {
        0% { visibility: visible; stroke-dashoffset: 247; }
        100% {visibility: visible; stroke-dashoffset: 0; }
    }
    @keyframes sigO {
        0% { visibility: visible; stroke-dashoffset: 348; }
        100% { visibility: visible; stroke-dashoffset: 0; }
    }
    @keyframes sigB {
        0% { visibility: visible; stroke-dashoffset: 638; }
        100% { visibility: visible; stroke-dashoffset: 0; }
    }
    @keyframes sigR1 {
        0% { visibility: visible; stroke-dashoffset: 317; }
        100% { visibility: visible; stroke-dashoffset: 0; }
    }
    @keyframes sigR2 {
        0% { visibility: visible; stroke-dashoffset: 1430; }
        100% { visibility: visible; stroke-dashoffset: 0; }
    }
    @keyframes sigUnge {
        0% { visibility: visible; stroke-dashoffset: 2118; }
        100% { visibility: visible; stroke-dashoffset: 0; }
    }
    @keyframes sigLine {
        0% { visibility: visible; stroke-dashoffset: 1235; }
        100% { visibility: visible; stroke-dashoffset: 0; }
    }

    .sigPart {
        visibility: hidden;
    }

    #signature-svg {
        .sigJa {
            animation: sigJa .7s ease-in-out 1s forwards;
        }
        .sigC {
            animation: sigC .1s 1.75s forwards;
        }
        .sigO {
            animation: sigO .15s 1.9s forwards;
        }
        .sigB {
            animation: sigB .3s 2.15s forwards;
        }
        .sigR1 {
            animation: sigR1 .1s 2.55s forwards;
        }
        .sigR2 {
            animation: sigR2 .3s 2.75s forwards;
        }
        .sigUnge {
            animation: sigUnge 1.1s 3.1s linear forwards;
        }
        .sigLine {
            animation: sigLine .15s 4.4s forwards;
        }
    }

    #tagline, #top-links {
        font-size: 1.5em;
        color: white;
        align-self: flex-end;
        width: 90%;
        max-width: 20em;
        position: relative;

        strong {
            color: $yellow;
        }
    }
    
    #top-links {
        text-align: center;
        margin: 1em 0;
        width: 100%;
        max-width: 100%;

        a.box {
            font-size: .8em;
        }
    }

</style>
